import { Box, Paper, Stack, Typography } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import CampaignIcon from '@mui/icons-material/Campaign';
import { CustomButton } from '../../../../common/components';

const SendChecklist = ({
  summaryItems,
  onSend,
  canSend,
  isSending = false,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        border: '1px dashed',
        borderColor: 'primary.light',
        bgcolor: 'grey.50',
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} mb={1}>
        <CampaignIcon color="primary" />
        <Typography variant="subtitle1" fontWeight={700} color="primary.main">
          Checklist de envío
        </Typography>
      </Stack>

      <Stack spacing={1.5}>
        {summaryItems.map((item) => (
          <Box key={item.label}>
            <Typography variant="caption" color="text.secondary">
              {item.label}
            </Typography>
            <Typography variant="body1">{item.value}</Typography>
          </Box>
        ))}
      </Stack>
      <CustomButton
        buttonIcon={SendIcon}
        onClick={onSend}
        sx={{ mt: 2, width: '100%' }}
        disabled={!canSend || isSending}
      >
        {isSending ? 'Enviando...' : 'Enviar'}
      </CustomButton>
    </Paper>
  );
};

export default SendChecklist;
